var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.theme.showRefresh
    ? _c("vab-icon", {
        attrs: { icon: "refresh-line" },
        on: { click: _vm.refreshRoute },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }